import { Badge, BadgeProps, ListItemText, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { FC } from 'react';
import { useUserContext } from '../UserContext';
import { Link } from 'react-router-dom';

export const ToolbarMenuItem: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { unreadNotifications: unreadComments } = useUserContext();

  return (
    <MenuItem component={Link} to="/notifications" onClick={onClick}>
      <ListItemText>Varslinger</ListItemText>
      {!!unreadComments && <Typography sx={{ color: 'text.secondary' }}>{unreadComments}</Typography>}
    </MenuItem>
  );
};

export const UnreadCommentsBadge: FC<BadgeProps> = (props) => {
  const { unreadNotifications: unreadComments } = useUserContext();

  return <Badge {...props} badgeContent={unreadComments} color="error" />;
};
